module.exports = __webpack_public_path__ + "e5b5d415de21994a1f09674e34cfd64e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/violin.png
// module id = 3062
// module chunks = 0